import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Booking from "../screens/auth/Booking";
import Profile from "../screens/auth/Profile";
// import Projects from "../screens/users/Projects";
import Blogs from "../screens/users/Blogs";
import Products from "../screens/users/Products";
import Category from "../screens/auth/Category";
import Product from "../screens/auth/Product";
import Inquiry from "../screens/auth/Inquiry";
import AuthBlogs from "../screens/auth/AuthBlogs";
import AuthFAQs from "../screens/auth/AuthFAQs";
import Testimonial from "../screens/auth/Testimonial";
import ProductDetails from "../screens/users/ProductDetails";
import EnquiryForm from "../screens/users/EnquiryForm";
import AuthGallery from "../screens/auth/AuthGallery";
import Gallery from "../screens/users/Gallery";
import AuthHero from "../screens/auth/AuthHero";
import Corporate from "../screens/users/Corporate";
import AuthCarrier from "../screens/auth/AuthCarrier";
import Carrier from "../screens/users/Carrier";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/bookings",
    component: <Booking />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/category",
    component: <Category />,
  },
  {
    path: "/product",
    component: <Product />,
  },
  {
    path: "/auth-hero",
    component: <AuthHero />,
  },
  {
    path: "/auth-gallery",
    component: <AuthGallery />,
  },
  {
    path: "/inquiry",
    component: <Inquiry />,
  },
  {
    path: "/auth-blog",
    component: <AuthBlogs />,
  },
  {
    path: "/auth-carrier",
    component: <AuthCarrier />,
  },
  {
    path: "/faq",
    component: <AuthFAQs />,
  },
  {
    path: "/testimonial",
    component: <Testimonial />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/products",
    component: <Products />,
  },
  {
    path: "/products/:id",
    component: <ProductDetails />,
  },
  {
    path: "/blog",
    component: <Blogs />,
  },
  {
    path: "/gallery",
    component: <Gallery />,
  },
  {
    path: "/corporate",
    component: <Corporate />,
  },
  {
    path: "/carrier",
    component: <Carrier />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/enquiry",
    component: <EnquiryForm />,
  },
];
